/**
 * Contact form: honeypot plus a minimum delay, alongside Shopify's own
 * hCaptcha, and the Nuwa launcher in the cartouche.
 */
(function () {
  'use strict';
  const bq = window.bq;
  if (!bq) return;

  function init(root) {
    if (!root || root.dataset.bqContactInit) return;
    root.dataset.bqContactInit = '1';

    const form = root.querySelector('.bq-lettre__form');
    if (form) {
      const opened = Date.now();
      let armed = true;
      form.addEventListener('submit', function (e) {
        const hp = form.querySelector('[name="contact[website]"]');
        // Honeypot filled: silent block.
        if (hp && hp.value) {
          e.preventDefault();
          return;
        }
        // Sent under 2.5s after load: blocked once, a manual resend passes.
        if (armed && Date.now() - opened < 2500) {
          e.preventDefault();
          armed = false;
        }
      });
    }

    bq.wireNuwa(root, '[data-contact-nuwa]');
  }

  document.querySelectorAll('.bq-contact').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.bq-contact').forEach(init);
  });
})();
